const styles = (theme) => ({
  catalogMenuText: {
    fontSize: 16,
    fontFamily: 'neuzeit-grotesk, sans-serif',
    fontWeight: 'normal',
    opacity: 0.8,
    letterSpacing: 0.16,
    color: theme.color.black,
  },
  title: {
    margin: theme.spacing(2.5, 0, 1.5, 0),
    color: theme.color.grey_8A,
    opacity: 1,
  },
  listItemText: {
    marginRight: '9%',
    marginBottom: theme.spacing(2.5),
    flex: 'none',
    width: 17,
  },
  listItem: {
    flexWrap: 'wrap',
    width: '100%',
    paddingLeft: 0,
    marginTop: 20,
    paddingRight: 0,
  },
  alphaIndexTitle: {
    opacity: 1,
    fontWeight: 'normal',
  },
  disabled: {
    color: theme.color.grey_8A,
    opacity: 0.5,
  },
  container: {
    paddingTop: theme.spacing(0.25),
    paddingLeft: theme.spacing(2),
    marginBottom: theme.spacing(2.25),
    position: 'relative',
    scrollMargin: 20,

    '& .MuiListItem-button': {
      paddingLeft: 0,
    },
  },
  spacingBottom: {
    marginBottom: 110,
  },
  list: {
    paddingLeft: theme.spacing(2),
    scrollMargin: 80,
  },
  designerSecondaryItem: {
    margin: theme.spacing(0, 2),
  },
  noResults: {
    padding: 40,
  },
  divider: {
    margin: 0,
    padding: 0,
  },
  loadingPlaceholder: {
    opacity: 1,
    minHeight: 270,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkbox: {
    margin: 0,
    marginBottom: -4,
    padding: 0,
    paddingRight: theme.spacing(2.5),
  },
  saChecked: {
    margin: 0,
    marginBottom: -4,
    padding: 0,
    paddingRight: theme.spacing(2.5),
    fill: theme.color.teal,
  },
  labelRoot: {
    marginTop: theme.spacing(2.5),
    margin: 0,
  },
  backToTop: {
    bottom: 75,
  },
  backToTopIcon: {
    bottom: 113,
  },
  loader: {
    margin: 'auto',
    position: 'absolute',
    top: 'calc(50% - 20px)',
    left: 'calc(50% - 20px)',
  },

  autoSizerContainer: {
    flex: '1 1 auto',
    height: '95vh',
  },
});

export default styles;
